import { CircularProgress, IconButton } from "@mui/material";
import React, { useState } from "react";
import * as XLSX from "xlsx";
import {
  API_URL,
  BootstrapTooltip,
  chekEmptyField,
  convertJalaaliToGregorian,
  handleSendMessage,
} from "src/utilities";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { IAppUser } from "src/interface/IUser";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "src/context/auth";
import { TypeUser } from "src/interface/enum/TypeUser";

export default function ImportExcelButton({
  notify,
  refetch,
}: {
  notify: any;
  refetch: any;
}) {
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "user/by-excel", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutateAsync: insertAppUserSystem, isPending: systemLoading } =
    useMutation({
      mutationFn: async (body: any) => {
        const response = await fetch(API_URL + "appUser-websystem", {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
          body: JSON.stringify(body),
        });
        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  const handleFileUpload = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e: any) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const sheetData: any[] = XLSX.utils.sheet_to_json(sheet) ?? [];
        if (sheetData.length > 0) {
          // ایجاد آرایه از عملیات‌های غیرهمزمان (Promise)
          const promises = sheetData.map(async (row: any, index: number) => {
            const NewUser: IAppUser = {
              isActive: true,
              birthDate: chekEmptyField(row?.birthDate)
                ? convertJalaaliToGregorian(row?.birthDate)
                : undefined,
              cityId: undefined,
              codePersonel: chekEmptyField(row?.codePersonel),
              coName: chekEmptyField(row?.coName),
              phoneNumber: chekEmptyField(row?.phoneNumber, "09130000000"),
              email: chekEmptyField(row?.email),
              economicCode_OLD: chekEmptyField(row?.economicCode_OLD),
              nationalId: chekEmptyField(row?.nationalId),
              gender: row.gender,
              typeUser: row.typeUser,
              roleName: TypeUser.CUSTOMER,
              fName: chekEmptyField(row?.fName),
              lName: chekEmptyField(row?.lName),
              fatherName: chekEmptyField(row?.fatherName),
              telNumber: chekEmptyField(row?.telNumber),
              coTelNumber: chekEmptyField(row?.coTelNumber),
              nationalCode: chekEmptyField(row?.nationalCode),
              caseNumber: chekEmptyField(row?.caseNumber),
              postalCode: chekEmptyField(row?.postalCode),
              address: chekEmptyField(row?.address),
              coTaxFileClass: chekEmptyField(row?.coTaxFileClass),
              desc: chekEmptyField(row?.desc),
            };
            const res = await insertAsync(NewUser);

            if (res.status === true) {
              if (row["13_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 13,
                  userName: row["13_user"],
                  password: row["13_pw"],
                  trackingCode: undefined, // کد رهگیری
                });
              }
              if (row["14_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 14,
                  userName: row["14_user"],
                  password: row["14_pw"],
                  trackingCode: undefined, // کد رهگیری
                });
              }
              if (row["7_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 7,
                  userName: row["7_user"],
                  password: row["7_pw"],
                  trackingCode: undefined, // کد رهگیری
                });
              }
              if (row["9_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 9,
                  userName: row["9_user"],
                  password: row["9_pw"],
                  trackingCode: row["9_trackingCode"], // کد رهگیری
                });
              }
              if (row["12_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 12,
                  userName: row["12_user"],
                  password: row["12_pw"],
                  trackingCode: undefined, // کد رهگیری
                });
              }
              if (row["10_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 10,
                  userName: row["10_user"],
                  password: row["10_pw"],
                  trackingCode: undefined, // کد رهگیری
                });
              }
              if (row["11_user"]) {
                await insertAppUserSystem({
                  customerRef: res?.data?.id,
                  systemRef: 11,
                  userName: row["11_user"],
                  password: row["11_pw"],
                  trackingCode: undefined, // کد رهگیری
                });
              }
            } else {
              let errorMessage =
                "کاربر " + NewUser.fName + " " + NewUser.lName + " ثبت نشد";

              if (res.data === "شماره پرونده تکراری است!") {
                errorMessage += " - شماره پرونده تکراری است";
              } else if (res.data === "userName already Exist!") {
                errorMessage += " - نام کاربری تکراری است";
              } else {
                errorMessage += " به کد ملی " + NewUser.nationalCode;
              }

              handleSendMessage(
                notify,
                errorMessage,
                "error",
                5000,
                "error" + index
              );
            }
          });

          try {
            // صبر کردن برای پایان تمام عملیات‌های insertAsync
            await Promise.all(promises);

            // زمانی که همه‌ی عملیات‌ها به پایان رسید
            refetch && refetch(); // فراخوانی مجدد داده‌ها
            handleSendMessage(
              notify,
              "ورود اطلاعات با موفقیت به انجام رسید",
              "success"
            );
          } catch (error) {
            // در صورت بروز خطا
            handleSendMessage(notify, "خطا در هنگام ثبت داده‌ها.", "error");
          }
        }
      };

      reader.readAsBinaryString(file);
    }
  };

  return (
    <BootstrapTooltip title="افزودن کاربران از طریق فایل Excel">
      <IconButton
        disabled={isPending}
        size="large"
        color="warning"
        component="label" // تبدیل به یک عنصر <label>
      >
        {(isPending && <CircularProgress size={20} />) || (
          <>
            <UploadFileIcon />
            <input type="file" hidden onChange={handleFileUpload} />
          </>
        )}
      </IconButton>
    </BootstrapTooltip>
  );
}
